module.exports = __webpack_public_path__ + "static/media/three-box-logo-dark.2b82cd0f.svg";